import React from 'react'
import PropTypes from 'prop-types'

import ContentBlock from '../components/ContentBlock'

import localization from '../localization/activities'

import img_hiking from '../assets/activities/hiking.jpg'
import img_bicycling from '../assets/activities/bicycling.jpg'
import img_bicycleRacing from '../assets/activities/bicycleRacing.jpg'
import img_mountainBiking from '../assets/activities/mountainBiking.jpg'
import img_kayaking from '../assets/activities/kayaking.jpg'
import img_rockClimbing from '../assets/activities/rockClimbing.jpg'
import img_winterSports from '../assets/activities/winterSports.jpg'
import img_golf from '../assets/activities/golf.jpg'
import img_archery from '../assets/activities/archery.jpg'
import img_motorCycling from '../assets/activities/motorCycling.jpg'

const ActivitiesPage = (props) => {
  const { language } = props

  return (
    <React.Fragment>
      <ContentBlock darkBackground>
        <h1 className="t-heading-xl">{localization[language].title}</h1>
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].hiking.title}</h2>
          <p>{localization[language].hiking.p1}</p>
          <p>{localization[language].hiking.p2}</p>
          <p>{localization[language].hiking.p3}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_hiking})` }} />
      </ContentBlock>

      <ContentBlock split darkBackground antiReverse>
        <div>
          {
            localization[language].hiking.trails.slice(0, Math.ceil(localization[language].hiking.trails.length / 2)).map(trail => (
              <React.Fragment key={trail.title}>
                <h3 className="t-heading-xs" style={{ marginBottom: 0 }}>{trail.title}</h3>
                {trail.text ? <p>{trail.text}</p> : <br />}
              </React.Fragment>
            ))
          }
        </div>

        <div>
          {
            localization[language].hiking.trails.slice((Math.ceil(localization[language].hiking.trails.length / 2))).map(trail => (
              <React.Fragment key={trail.title}>
                <h3 className="t-heading-xs" style={{ marginBottom: 0 }}>{trail.title}</h3>
                {trail.text ? <p>{trail.text}</p> : <br />}
              </React.Fragment>
            ))
          }
        </div>
      </ContentBlock>

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].bicycling.title}</h2>
          <p>{localization[language].bicycling.p1}</p>
          <p>{localization[language].bicycling.p2}</p>
          <p>{localization[language].bicycling.p3}</p>
          <p>{localization[language].bicycling.p4}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_bicycling})` }} />
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].bicycleRacing.title}</h2>
          <p>{localization[language].bicycleRacing.p1}</p>
          <p dangerouslySetInnerHTML={{ __html: localization[language].bicycleRacing.p2 }} />
        </div>

        <div style={{ backgroundImage: `url(${img_bicycleRacing})` }} />
      </ContentBlock>

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].mountainBiking.title}</h2>
          <p>{localization[language].mountainBiking.p1}</p>
          <p>{localization[language].mountainBiking.p2}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_mountainBiking})` }} />
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].kayaking.title}</h2>
          <p>{localization[language].kayaking.p1}</p>
          <p>{localization[language].kayaking.p2}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_kayaking})` }} />
      </ContentBlock>

      <ContentBlock split darkBackground antiReverse noMinHeight>
        <div>
          {
            localization[language].kayaking.rivers.slice(0, Math.ceil(localization[language].kayaking.rivers.length / 2)).map(river => (
              <React.Fragment key={river.title}>
                <h3 className="t-heading-xs" style={{ marginBottom: 0 }}>{river.title} (WW {river.class})</h3>
                {river.text ? <p>{river.text}</p> : <br />}
              </React.Fragment>
            ))
          }
        </div>

        <div>
          {
            localization[language].kayaking.rivers.slice((Math.ceil(localization[language].kayaking.rivers.length / 2))).map(river => (
              <React.Fragment key={river.title}>
                <h3 className="t-heading-xs" style={{ marginBottom: 0 }}>{river.title} (WW {river.class})</h3>
                {river.text ? <p>{river.text}</p> : <br />}
              </React.Fragment>
            ))
          }
        </div>
      </ContentBlock>

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].rockClimbing.title}</h2>
          <p>{localization[language].rockClimbing.p1}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_rockClimbing})` }} />
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].winterSports.title}</h2>
          <p>{localization[language].winterSports.p1}</p>
          <p>{localization[language].winterSports.p2}</p>
          <ul>{localization[language].winterSports.tracks.map(track => <li key={track}>{track}</li>)}</ul>
          <p dangerouslySetInnerHTML={{ __html: localization[language].winterSports.p3 }} />
        </div>

        <div style={{ backgroundImage: `url(${img_winterSports})` }} />
      </ContentBlock>

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].golf.title}</h2>
          <p dangerouslySetInnerHTML={{ __html: localization[language].golf.p1 }} />
          <p>{localization[language].golf.p2}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_golf})` }} />
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].archery.title}</h2>
          <p dangerouslySetInnerHTML={{ __html: localization[language].archery.p1 }} />
        </div>

        <div style={{ backgroundImage: `url(${img_archery})` }} />
      </ContentBlock>

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].motorCycling.title}</h2>
          <p>{localization[language].motorCycling.p1}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_motorCycling})` }} />
      </ContentBlock>
    </React.Fragment>
  )
}

ActivitiesPage.propTypes = {
  language: PropTypes.string.isRequired,
}

export default ActivitiesPage



// WEBPACK FOOTER //
// ./src/pages/activities.js